import { render, staticRenderFns } from "./PermissionsSimple.vue?vue&type=template&id=57c9da90"
import script from "./PermissionsSimple.vue?vue&type=script&lang=js"
export * from "./PermissionsSimple.vue?vue&type=script&lang=js"
import style0 from "./PermissionsSimple.vue?vue&type=style&index=0&id=57c9da90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports